// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"DataTable_lightTheme__2f0K9","darkTheme":"DataTable_darkTheme__24WPQ"};